import React, { SyntheticEvent, useState } from 'react';
import Link from '@material-ui/core/Link';
import { Alert } from '@material-ui/lab';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleLogin } from '../../data/coreActions';
import RegisterForm from './RegisterForm';
import GoogleButton, { GOOGLE_SIGN_IN_ENABLED } from './GoogleButton';
import { signInWithGoogle } from './googleSignIn';
import { post } from '../../utils/ajax';
import { localRoutes, remoteRoutes } from '../../data/constants';
import Toast from '../../utils/Toast';
import { useLoginStyles } from './loginStyles';
import AuthLayout from './AuthLayout';

export default function Register() {
  const classes = useLoginStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [done, setDone] = useState<boolean>(false);
  // Set when Login handed us a verified Google profile to finish off.

  // Someone who starts on this page can also use Google. If the address is
  // already registered we send them straight in rather than make them fail
  // a duplicate-email check.
  const onGoogleCredential = (credential: string) => {
    signInWithGoogle(
      credential,
      (session) => {
        // Google gave us a name and a verified address — everything the
        // form would have asked for. Straight in; hub and course are
        // collected when they enrol.
        dispatch(handleLogin(session));
        Toast.success('Welcome to era92 elevate');
        history.push(localRoutes.dashboard);
      },
      (msg) => Toast.error(msg),
    );
  };

  function handleDone() {
    setDone(true);
  }

  function handleLogin(e: SyntheticEvent<any>) {
    e.preventDefault();
    history.push(localRoutes.login);
  }

  return (
    <AuthLayout title="Sign up Account" subtitle="Student's Portal">
      {done && (
        <Alert severity="success" className={classes.alert}>
          Thank you for joining era92 elevate! Your account is ready — you can
          now sign in with your email and password.
        </Alert>
      )}

      <div className={classes.formLabel}>Enter your details</div>

      <div className={classes.form}>
        <RegisterForm data={{}} done={handleDone} />
      </div>

      {GOOGLE_SIGN_IN_ENABLED && !done && (
        <GoogleButton onCredential={onGoogleCredential} text="signup_with" />
      )}

      <div className={classes.footerText}>
        Do you have an account?{' '}
        <Link
          className={`${classes.link} ${classes.linkAccent}`}
          onClick={handleLogin}
        >
          Log in
        </Link>
      </div>
    </AuthLayout>
  );
}
